import { OrganizationKindSelectValue } from './types';

export const ORGANIZATION_KIND_ALL = 'all';

export const ORGANIZATION_KIND_SELECT_VALUES: OrganizationKindSelectValue[] = [
  ORGANIZATION_KIND_ALL,
  'ShowDistributors',
  'ShowDistributorClients',
  'ShowDSOs',
  'ShowDSOClients',
];
